import { render, staticRenderFns } from "./LeadershipVideoSubmission.vue?vue&type=template&id=2584fc6e&scoped=true"
import script from "./LeadershipVideoSubmission.vue?vue&type=script&lang=js"
export * from "./LeadershipVideoSubmission.vue?vue&type=script&lang=js"
import style0 from "./LeadershipVideoSubmission.vue?vue&type=style&index=0&id=2584fc6e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2584fc6e",
  null
  
)

export default component.exports